import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { CTASection } from "@/components/common/CTASection";
import { WHY_NOIDA, IMAGES } from "@/lib/content";
import { MapPin } from "lucide-react";

export default function WhyNoida() {
  return (
    <>
      <PageHero
        kicker="Why Noida"
        title="Why Noida for your India operations?"
        subtitle="Noida, in the Delhi-NCR region, offers strong technology talent, modern infrastructure, and competitive costs. It's where our local strength lies."
        image={IMAGES.noidaSunrise}
      />

      <section className="section-pad" data-testid="why-noida-content">
        <div className="container-px grid gap-14 lg:grid-cols-2 lg:items-start">
          <div className="lg:sticky lg:top-28">
            <SectionHeading kicker="Our Home Base" title="A smart base for technology operations." />
            <Reveal i={2}>
              <p className="text-zinc-400">
                We recommend the right location for your specific needs — but for many technology
                companies, Noida is a compelling place to start and scale. Here's why.
              </p>
              <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-orange-500/20 bg-orange-500/5 px-4 py-2 text-sm text-orange-300">
                <MapPin className="h-4 w-4" /> Noida · Delhi NCR · India
              </div>
            </Reveal>
            <Reveal i={3}>
              <div className="mt-8 overflow-hidden rounded-2xl border border-white/10">
                <img src={IMAGES.noidaNight} alt="Noida NCR at night" className="h-56 w-full object-cover" />
              </div>
            </Reveal>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            {WHY_NOIDA.map((p, i) => (
              <Reveal key={p.title} i={i}>
                <div className="h-full rounded-2xl border border-white/8 bg-white/[0.02] p-6 transition-colors hover:border-orange-500/30">
                  <h3 className="font-head text-base font-bold text-white">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-zinc-400">{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
